/**
 * SecurityProtection Component
 * Provides visual watermark protection for screenshot identification.
 * Text selection, copy/paste, and normal browser functions are allowed.
 */

import { useAuth } from '@/contexts/AuthContext';
import { useLocation } from 'react-router-dom';

const SecurityProtection = ({ children }) => {
  const { user } = useAuth();
  const { pathname, hash } = useLocation();
  // O leitor editorial não inclui identificação privada na impressão/corpo visual.
  if (pathname.startsWith('/marketplace-admin/noticias/') || pathname.startsWith('/noticias-tvde') ||
      pathname === '/marketplace-admin/audiencia' || (pathname === '/marketplace-admin' && hash === '#audiencia')) {
    return children;
  }

  return (
    <>
      {children}
      {/* Dynamic watermark with user identification */}
      {user && (
        <div
          className="security-watermark"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999,
            overflow: 'hidden',
            opacity: 0.03,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-50%',
              left: '-50%',
              width: '200%',
              height: '200%',
              transform: 'rotate(-30deg)',
              display: 'flex',
              flexWrap: 'wrap',
              alignContent: 'flex-start',
              gap: '80px',
            }}
          >
            {Array.from({ length: 60 }).map((_, i) => (
              <div
                key={i}
                style={{
                  color: '#666',
                  fontSize: '12px',
                  fontWeight: '500',
                  whiteSpace: 'nowrap',
                  userSelect: 'none',
                  padding: '40px',
                  fontFamily: 'monospace',
                }}
              >
                {user.email} • {user.nome?.split(' ')[0] || ''} • {new Date().toLocaleDateString('pt-PT')}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SecurityProtection;
